import {Controller} from "react-hook-form";

const InputMinutesLate = ({control, fieldName, disabled}) =>
{
    return (
        <div>
            <Controller control={control} rules = {{maxLength: 3}} name={fieldName} render={({field: {onChange, value}}) =>
                (
                    <input className="form-control" type="number" disabled={disabled} onChange={onChange} value={value} style={{width: "100%", height: "100%"}}/>
                )}></Controller>
        </div>
    )
}

export default InputMinutesLate;